import React from "react";


const Tooltip = ({ text }) => {
    if (!text) return null; // Safety check: if no text is passed, don't render anything
  
    return (
      
      <div className="pointer-events-none absolute bottom-full left-4 mb-2 z-30 w-max max-w-xs translate-y-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
        <div className="relative rounded-lg bg-slate-800 px-3 py-2.5 text-xs font-medium tracking-wide text-white shadow-xl">
          {text}
          
          {/* The downward-pointing triangle arrow */}
          <svg 
            className="absolute -bottom-1.5 left-4 h-2 w-4 text-slate-800" 
            fill="currentColor" 
            viewBox="0 0 8 4"
          >
            <path d="M0 0l4 4 4-4H0z" />
          </svg>
        </div>
      </div>
    );
  };

export default Tooltip;